
<div [ngClass]="['course-header-edit', courseCssService.responsiveClass()]">
  <div class='options'>
    <div class='labeled-popup '>
      <label>Collection</label>
      <button class='collection' (click)='chooseCollection($event)'>
        {{resources?.findCollection(course.collectionUuid)?.name}}</button>
    </div>
    <div class='separator'><div></div></div>
    <div class="date-input">
      <div class='labeled-popup'>
        <label>Select Date</label>
        <button class='month' (click)="chooseDate($event)">{{getSelectedDate()}}</button>
      </div>
    </div>
    <!-- <div class='date-input'>
      <div class='labeled-popup'>
        <label>Start Month</label>
        <button class='month' (click)='chooseMonth($event)'>{{course.startDate.month || ''}}</button>
      </div>
      <div class='labeled-popup'>
        <label>Day</label>
        <button class='day' (click)='chooseDay($event)'>{{course.startDate.day || ''}}</button>
      </div>
      <div class='labeled-popup'>
        <label>Year</label>
        <button class='year' (click)='chooseYear($event)'>{{course.startDate.year || ''}}</button>
      </div>
    </div> -->
    <div class='separator'><div></div></div>
    <div class='labeled-popup'>
      <label>Class Type</label>
      <button class='type' (click)='chooseClassType($event)'>{{course.classType || ''}}</button>
    </div>
  </div>
  <div class='actions'>
    <button class='cancel' (click)='cancelEdit()'>Cancel</button>
    <button class='save' [disabled]='!isSaveEnabled()' (click)='saveEdit()'>Save</button>
  </div>
</div>